<span *ngIf="remainingFaqs?.length > 0 || faqData?.faqsList?.length > 0" class="heading-strip text-center">
  Frequently Asked Question(s)
</span>
<div *ngIf="remainingFaqs?.length > 0 || faqData?.faqsList?.length > 0" class="panel-group fltr faq-accordion">

  <!-- Displaying remainingFaqs -->
  <div *ngIf="!homepageFaq">
    <ng-container *ngFor="let faq of remainingFaqs; let i = index">
      <div class="panel" [ngClass]="{ 'panel-open': faqtabDataAccordion[i] }">
        <div class="panel card panel-default">
          <div class="panel-heading card-header panel-enabled" (click)="faqTabToggle(i)">
            <div class="panel-title">
              <div class="accordion-toggle">
                <button type="button" class="btn btn-link">
                  <b>{{ faq.question }}</b>
                </button>
              </div>
            </div>
          </div>
          <div class="panel-collapse"  [@accordionToggle]="faqtabDataAccordion[i] ? 'open' : 'closed'"
           >
            <!-- <div class="panel-body card-block card-body">{{ faq.answer }}</div> -->
            <div class="panel-body card-block card-body" [innerHTML]="getFormattedAnswer(faq.answer)"></div>
            <div *ngIf="faq?.tabularDataList?.length > 0">
              <div class="table-container">
                <table class="table table-bordered faq-table">
                  <thead>
                    <tr>
                      <th class="title-cell">
                        <ng-container>
                          <span *ngIf="faq?.tabularDataList[0]?.tenderTitle">Tender Title</span>
                          <span
                            *ngIf="!faq?.tabularDataList[0]?.tenderTitle && faq?.tabularDataList[0]?.categoryName">Category
                            Name</span>
                        </ng-container>
                      </th>
                      <th *ngIf="faq?.tabularDataList[0]?.closingDate || faq?.tabularDataList[0]?.openingDate"
                        class="date-cell white-space-nowrap">
                        <ng-container>
                          <span class="white-space-nowrap block" *ngIf="faq?.tabularDataList[0]?.closingDate">Closing
                            Date</span>
                          <span class="white-space-nowrap block" *ngIf="faq?.tabularDataList[0]?.openingDate">Opening
                            Date</span>
                        </ng-container>
                      </th>
                      <th *ngIf="faq?.tabularDataList[0]?.authorityName || faq?.tabularDataList[0]?.categoryCount"
                        class="authority-cell">
                        <ng-container>
                          <span *ngIf="faq?.tabularDataList[0]?.authorityName">Authority Name</span>
                          <span
                            *ngIf="!faq?.tabularDataList[0]?.authorityName && faq?.tabularDataList[0]?.categoryCount">Tender
                            Counts</span>
                        </ng-container>
                      </th>
                      <th *ngIf="faq?.tabularDataList[0]?.tenderValue" class="tenderValue-cell">
                        <ng-container>
                          <span *ngIf="faq?.tabularDataList[0]?.tenderValue">Tender
                            Value</span>
                        </ng-container>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let tabledata of faq?.tabularDataList">
                      <td class="title-cell" *ngIf="tabledata.detailPageUrl || tabledata.categoryPageUrl">
                        <span class="table-title">
                          <a [href]="tabledata.detailPageUrl || tabledata.categoryPageUrl" target="_blank">
                            <span class="table-title">
                              {{ tabledata.tenderTitle || tabledata?.categoryName }}
                            </span>
                          </a>
                        </span>
                      </td>
                      <td *ngIf="faq?.tabularDataList[0]?.closingDate || faq?.tabularDataList[0]?.openingDate"
                        class="date-cell white-space-nowrap">
                        {{ tabledata.closingDate ||tabledata.openingDate | date: 'MM/dd/yyyy' }}
                      </td>
                      <td *ngIf="faq?.tabularDataList[0]?.authorityName || faq?.tabularDataList[0]?.categoryCount"
                        class="authority-cell">
                        <a *ngIf="faq?.tabularDataList[0]?.authorityName" [href]="tabledata.authorityPageUrl"
                          target="_blank">
                          <span class="table-title">
                            {{ tabledata?.authorityName }}
                          </span>
                        </a>

                        <span *ngIf="faq?.tabularDataList[0]?.categoryCount">
                          {{ tabledata?.categoryCount }}
                        </span>
                      </td>
                      <td *ngIf="faq?.tabularDataList[0]?.tenderValue" class="tenderValue-cell">
                        <ng-container>
                          <span *ngIf="faq?.tabularDataList[0]?.tenderValue">{{
                            (tabledata?.tenderValue === 0 ? 'Refer Document' : (tabledata?.tenderValue |
                            tenderAmount))}}</span>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="showFaqList">
      <ng-container *ngFor="let faq of faqData?.faqsList; let i = index">
        <div class="panel"  > 
          <div class="panel card panel-default">
            <div class="panel-heading card-header panel-enabled" (click)="faqToggle(i)">
              <div class="panel-title">
                <div class="accordion-toggle">
                  <button type="button" class="btn btn-link">
                    <b>{{ faq.question }}</b>
                  </button>
                </div>
              </div>
            </div>
            <div class="panel-collapse"  [@accordionToggle]="i === faqAccordion ? 'open' : 'closed'">
              <div class="panel-body card-block card-body">{{ faq.answer }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <div *ngIf="showButton" class="row justify-content-center mt-20">
      <button *ngIf="faqData?.faqsList?.length > 0" (click)="toggleFaqList()"
        class="btn btn-primary pagination-see-more">
        {{ showFaqList ? 'Show Less FAQ' : 'Show More FAQ' }}
        <i [ngClass]="showFaqList ? 'arrow-up' : ''"></i>
      </button>
    </div>
  </div>

  <div *ngIf="homepageFaq && showHomeFaqList">
      <ng-container *ngFor="let faq of combinedFaqsList; let i = index">
        <div class="panel" [ngClass]="{ 'panel-open': i === openFaqIndex }" >
          <div class="panel card panel-default">
            <div class="panel-heading card-header panel-enabled" (click)="faqHomepageToggle(i)">
              <div class="panel-title">
                <div class="accordion-toggle">
                  <button type="button" class="btn btn-link">
                    <b>{{ faq.question }}</b>
                  </button>
                </div>
              </div>
            </div>
            <div class="panel-collapse"  [@accordionToggle]="i === openFaqIndex  ? 'open' : 'closed'">
              <div class="panel-body card-block card-body">{{ faq.answer }}</div>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="faqData?.faqsList.length > 5" class="row justify-content-center mt-20">
        <button (click)="toggleFaqVisibility()"
          class="btn btn-primary pagination-see-more">
          {{ isExpanded ? 'Show Less FAQ' : 'Show More FAQ' }}
          <i [ngClass]="isExpanded ? 'arrow-up' : ''"></i>
        </button>
      </div>
  </div>

</div>